module.exports = __webpack_public_path__ + "static/img/blog_3.22f03d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog_3.jpg
// module id = iNG9
// module chunks = 0